import * as React from 'react';

import { use$ } from '@legendapp/state/react';

import useContainerPosition from '../product-view/hooks/use-container-position';

import { ProductView, TrackingEventName } from '../../store/stores/tracking/types';

import { deviceSettingStore, dragOverlayStore, dragOverlayStoreActions } from '../../store';
import { trackingStore } from '../../store/stores/tracking-store';
import { DesktopOnboarding } from './desktop-onboarding/desktop-onboarding';
import { TouchDeviceOnboarding } from './touch-device-onboarding/touch-device-onboarding';

export const TwoDOnboarding = () => {
	const isTouchDevice = use$(deviceSettingStore.isTouchDevice);
	const isDragOverlayVisible = use$(dragOverlayStore.isDragOverlayVisible);

	const { handlePositionChange } = useContainerPosition();

	const track = trackingStore.track;

	function handleOnboardingClick() {
		if (!isDragOverlayVisible) return;

		handlePositionChange();
		track(TrackingEventName.VISUALIZER_INTERACTION, {
			sectionName: ProductView.EXTERNAL_VIEW
		});
		dragOverlayStoreActions.setIsDragOverlayVisible(false);
	}

	return (
		isDragOverlayVisible &&
		(isTouchDevice ? (
			<TouchDeviceOnboarding handleClick={handleOnboardingClick} />
		) : (
			<DesktopOnboarding handleClick={handleOnboardingClick} />
		))
	);
};
